import * as React from 'react';
import type { SVGProps } from 'react';

interface SvgWarningProps extends SVGProps<SVGSVGElement> {
  pathFill?: string;
}

const SvgWarning = ({ pathFill = "#FE5000", ...props }: SvgWarningProps) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill="none" {...props}>
    <path fill={pathFill} fillRule="evenodd" d="M16 15.5H0v-3l7-12h2l7 12zm-9-11h2v5H7zm0 7h2v2H7z" clipRule="evenodd" />
  </svg>
);
export default SvgWarning;
